export default function MobileActionBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
      <div className="flex items-center gap-3">
        <a
          href="tel:+919940148039"
          className="flex-1 whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-xl font-label text-sm font-semibold transition-all duration-200 cursor-pointer"
          style={{ backgroundColor: '#0167F8', color: '#FFFFFF', padding: '12px 16px' }}
        >
          <i className="ri-phone-line"></i>
          Call
        </a>
        <a
          href="https://wa.me/919940148039"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-xl font-label text-sm font-semibold transition-all duration-200 cursor-pointer border border-green-500 text-green-600"
          style={{ padding: '12px 16px' }}
        >
          <i className="ri-whatsapp-line"></i>
          WhatsApp
        </a>
      </div>
    </div>
  );
}